module.exports = __webpack_public_path__ + "static/media/MLH.5659273c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MLH.jpg
// module id = 1770
// module chunks = 1